import { useState, useEffect } from 'react';

const navItems = [
  { label: '热播专题', anchor: '#carousel' },
  { label: '热门榜单', anchor: '#ranking' },
  { label: '最新动态', anchor: '#updates' },
  { label: '影视合集', anchor: '#index' },
  { label: '常见问题', anchor: '#faq' },
  { label: '联系我们', anchor: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (anchor: string) => {
    setMobileOpen(false);
    const el = document.querySelector(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#hero');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-xl text-white"></i>
            </div>
            <span
              className="text-xl font-bold tracking-tight whitespace-nowrap"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              91在线视频
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#hero');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.anchor}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
          >
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.anchor}
              href={item.anchor}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.anchor);
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}